import { Component, OnInit } from '@angular/core';
import { UtilsService } from 'src/app/services/utils.service';
import { ManageLineService } from 'src/app/services/manage-line.service';
import { Router } from '@angular/router';
import { PDLService } from 'src/app/services/pdl-service.service';
import { ANALYTICS } from 'src/app/common/core/common.constants';

@Component({
  selector: 'app-submit-documentation-failure',
  templateUrl: './submit-documentation-failure.component.html',
  styleUrls: ['./submit-documentation-failure.component.scss']
})
export class SubmitDocumentationFailureComponent implements OnInit {
  militaryVerficationDocumentUpload: any;
  constructor(public utilsSvc: UtilsService,public manageLineService: ManageLineService,
              private router: Router, private pdlService: PDLService) { }

  ngOnInit() {
    this.militaryVerficationDocumentUpload = this.utilsSvc.getContentDataFromSession();

    this.pdlService.ifEnabledGenerateModalViewTag({
      eventAction: ANALYTICS.LOAD,
      modalName: this.militaryVerficationDocumentUpload.militaryVerficationDocumentUpload.analyticsMilitaryFailureAfterDocLoad,
      stage: this.militaryVerficationDocumentUpload.militaryVerification.analyticsComplete
    });
  }

  openUploadDocumentScreen() {
    this.router.navigate(['/apps/tfb_acctmgmt/account-management/affiliations/military-verification']);
    this.manageLineService.close();

    this.pdlService.ifEnabledGenerateClickTag({
      type: ANALYTICS.CLICK_TO_NAVIGATE,
      action: ANALYTICS.CLICK,
      ctaName: this.militaryVerficationDocumentUpload.militaryVerficationDocumentUpload.startOver,
      assetType: ANALYTICS.BUTTON,
      modalName:this.militaryVerficationDocumentUpload.militaryVerficationDocumentUpload.analyticsMilitaryFailureAfterDocLoad
    });
  }

  onClose(){
    this.manageLineService.close();
    this.pdlService.ifEnabledGenerateClickTag({
      type: ANALYTICS.CLICK_TO_ACTION,
      action: ANALYTICS.CLICK,
      ctaName: this.militaryVerficationDocumentUpload.militaryVerification.cancel,
      assetType: ANALYTICS.BUTTON,
      modalName:this.militaryVerficationDocumentUpload.militaryVerficationDocumentUpload.analyticsMilitaryFailureAfterDocLoad
    });
  }
}
